import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDropdownToggle } from '@restart/ui';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import { Button } from '../Button';
export const DropdownToggle = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { split, className, componentClass: Component = Button, ...rest } = props;
    const [toggleProps] = useDropdownToggle();
    const reffy = useMergedRefs(toggleProps.ref, ref);
    return /*#__PURE__*/ _jsx(Component, {
        className: classNames(className, 'dropdown-toggle', split && 'dropdown-toggle-split'),
        ...toggleProps,
        ref: reffy,
        ...rest
    });
});
DropdownToggle.displayName = 'DropdownToggle';
